import type { Organization } from "@/app/organizations/types";
import { getCoordinatorApi } from "@/lib/api";

type UpdateOrganizationPayload = {
  name?: string;
  description?: string;
};

export type UpdateOrganizationVariables = {
  organizationId: string;
  data: UpdateOrganizationPayload;
};

type ApiResponse<T> = {
  code: number;
  msg: string;
  data: T;
};

export const updateOrganization = async ({
  organizationId,
  data,
}: UpdateOrganizationVariables): Promise<Organization> => {
  const api = getCoordinatorApi({ organizationId });
  const { data: response } = await api.put<ApiResponse<Organization>>("", data);
  return response.data;
};
